<div class="registration">
  <div class="registration-card">
    <div class="logo-image">
      <img src="assets/img/logo.jpg" alt="Logo" />
    </div>

    <div *ngIf="!isLoading">
      <app-panel>
        <div class="registration-result">
          <ng-container *ngIf="hasError; else success">
            <div class="title">
              {{ 'BROKER-REGISTRATION.CONFIRMATION.ERROR.TITLE' | translate }}
            </div>
            <div class="description">
              {{ 'BROKER-REGISTRATION.CONFIRMATION.ERROR.DESCRIPTION' | translate }}
            </div>
          </ng-container>

          <ng-template #success>
            <ng-container
              *ngIf="confirmationType === BrokerRegistrationConfirmationType.ApprovalRequired"
            >
              <div class="title">
                {{ 'BROKER-REGISTRATION.CONFIRMATION.APPROVAL-REQUIRED.TITLE' | translate }}
              </div>
              <div class="description">
                {{ 'BROKER-REGISTRATION.CONFIRMATION.APPROVAL-REQUIRED.DESCRIPTION' | translate }}
              </div>
            </ng-container>

            <ng-container
              *ngIf="confirmationType === BrokerRegistrationConfirmationType.AccountCreated"
            >
              <div class="title">
                {{ 'BROKER-REGISTRATION.CONFIRMATION.ACCOUNT-CREATED.TITLE' | translate }}
              </div>
              <div class="description">
                {{ 'BROKER-REGISTRATION.CONFIRMATION.ACCOUNT-CREATED.DESCRIPTION' | translate }}
              </div>
            </ng-container>
          </ng-template>
        </div>
      </app-panel>
    </div>
  </div>
</div>